import { render, staticRenderFns } from "./DashboardCitywiseDeliveryStatistics.vue?vue&type=template&id=38e12071&scoped=true&"
import script from "./DashboardCitywiseDeliveryStatistics.vue?vue&type=script&lang=js&"
export * from "./DashboardCitywiseDeliveryStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCitywiseDeliveryStatistics.vue?vue&type=style&index=0&id=38e12071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e12071",
  null
  
)

export default component.exports